/* SessionAgent.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5VijdnbC%7Bflex-grow%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNO7dHp%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bHrqEIZbP%7Bflex-basis%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02W9qI%7Bwidth%3A-moz-max-content%3Bwidth%3Amax-content%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17lj8p2ADO%7B-moz-column-gap%3Avar(--ds-space-100%2C8px)%3Bcolumn-gap%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAYvD1%7Boverflow-x%3Avisible%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGYvD1%7Boverflow-y%3Avisible%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIF6tL%7Bmin-width%3A2.5rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kk5Tkf7mX%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02xpxF%7Bwidth%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VxpxF%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02ey7F%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaTCRo%7Btransform%3Ascale(.75)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0yKXXaDIqT%7Btransform-origin%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaFk7q%7Btransform%3Atranslate(2px%2C1px)%20scale(.9375)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPca8SLj%7Btransform%3Ascale(.5)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaDWNG%7Btransform%3Ascale(.666667)%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import { RovoIcon } from '@atlaskit/logo';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { messages } from './messages';
const styles = {
  agents: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1EqgXlN91d _39xV02W9qI",
  agent: "_4ouGXIdnbC _3iDTPbccYA _0hPCNLDIqT _17lj8p2ADO",
  agentName: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
  defaultAgent: "_3YEZNOdnbC",
  defaultAgents: "_3YEZNOdnbC",
  iconOnlyAgents: "_4bt5LAYvD1 _2WAcuGYvD1 _3YEZNOdnbC",
  iconOnlyAgent: "_3YEZNOdnbC",
  defaultAgentName: "_4ouGXIF6tL",
  additionalAgents: "_3YEZNOdnbC _1kk5Tkf7mX"
};
const agentIconSizeStyles = {
  12: "_4bt5LAnQyn _2WAcuGnQyn _39xV02xpxF _0jFU0VxpxF _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
  16: "_4bt5LAnQyn _2WAcuGnQyn _39xV02ey7F _0jFU0Vey7F _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC"
};
const rovoAgentIconSizeStyles = {
  12: "_39xV02xpxF _0jFU0VxpxF _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
  16: "_39xV02ey7F _0jFU0Vey7F _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC"
};
const agentAvatarSizeStyles = {
  12: "_1VJPca8SLj",
  16: "_1VJPcaDWNG"
};
const rovoIconSizeStyles = {
  12: "_1VJPcaTCRo _0yKXXaDIqT",
  16: "_1VJPcaFk7q _0yKXXaDIqT"
};
export type SessionIconSize = 12 | 16;
export type SessionAgentDetails = {
  id: string;
  name: string;
  avatarUrl?: string;
  agentId?: string;
  agentIdentityAccountId?: string;
  agentNamedId?: string;
};
export type SessionAgentProps = {
  agents: ReadonlyArray<SessionAgentDetails>;
  /** Whether to render visible agent names alongside their avatars. */
  showNames?: boolean;
  /** Whether to render the standard Rovo icon instead of an agent avatar. */
  isDefaultAgent?: boolean;
  /** Visual size for agent icons. Defaults to 12. */
  iconSize?: SessionIconSize;
  additionalAgentCount?: number;
  testId?: string;
};

/** Renders the agents participating in a session and an optional overflow count. */
export const SessionAgent = ({
  agents,
  showNames = true,
  isDefaultAgent = false,
  iconSize = 12,
  additionalAgentCount,
  testId
}: SessionAgentProps): React.JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  if (agents.length === 0 && !additionalAgentCount) {
    return null;
  }
  return <Inline xcss={cx(styles.agents, isDefaultAgent && showNames && styles.defaultAgents, !showNames && styles.iconOnlyAgents)} alignBlock="center" space="space.100" testId={testId}>
			{agents.map(agent => <Box as="span" xcss={cx(styles.agent, isDefaultAgent && showNames && styles.defaultAgent, !showNames && styles.iconOnlyAgent)} key={agent.id}>
					{isDefaultAgent ? <Box xcss={rovoAgentIconSizeStyles[iconSize]} role="img" aria-label={agent.name}>
							<Box as="span" xcss={rovoIconSizeStyles[iconSize]}>
								<RovoIcon label="" size="xxsmall" />
							</Box>
						</Box> : <Box as="span" xcss={agentIconSizeStyles[iconSize]}>
							<Box as="span" xcss={agentAvatarSizeStyles[iconSize]}>
								<AgentAvatar size="small" imageUrl={agent.avatarUrl} name={agent.name} label={agent.name} agentId={agent.agentId} agentIdentityAccountId={agent.agentIdentityAccountId} agentNamedId={agent.agentNamedId} />
							</Box>
						</Box>}
					{showNames ? <Box as="span" xcss={cx(styles.agentName, isDefaultAgent && styles.defaultAgentName)}>
							{agent.name}
						</Box> : null}
				</Box>)}
			{additionalAgentCount && additionalAgentCount > 0 ? <Box as="span" xcss={styles.additionalAgents} role="img" aria-label={formatMessage(messages.additionalAgentsLabel, {
      count: additionalAgentCount
    })}>
					{formatMessage(messages.additionalAgents, {
        count: additionalAgentCount
      })}
				</Box> : null}
		</Inline>;
};